import {FeatureTypeComments} from '../../selectors';
import React from 'react';
import SingleComment from './SingleComment';
import CommentsModalFeatureComments from './CommentsModalFeatureComments';

type DeleteManyCommentsModalFeatureTypeCommentsProps = FeatureTypeComments;

export default class CommentsModalFeatureTypeComments extends React.Component<DeleteManyCommentsModalFeatureTypeCommentsProps, {}> {
    render() {
        const {featureTypeName, comments, features} = this.props;
        return <article>
            <h2>{featureTypeName}</h2>
            {comments.map(comment => (
                <SingleComment key={comment.id} comment={comment} commentResource={'FEATURE_COMMENT'}/>
            ))}

            <hr/>
            {
                Object.entries(features).map(([featureId, feature]) =>
                    <CommentsModalFeatureComments
                        key={featureId}
                        showTitle={Object.keys(features).length === 1 && feature.comments.length > 0}
                        featureName={feature.featureName}
                        comments={feature.comments}/>
                )
            }
        </article>;
    }
}
